import { updateLinks } from './linksFix';

// ### Window update
export const windowUpdate = () => {
  updateLinks();
};
export const removeReCaptchaBadge = () => {
  const list = [...document.querySelectorAll(".grecaptcha-badge")];
  list.forEach((el) => {
    const parentDiv = el.parentNode as HTMLElement | null;
    if (!parentDiv) return;
    parentDiv.removeChild(el);
    // remove DIV
    parentDiv.parentNode?.removeChild(parentDiv);
  })
}

// ### INIT
export const initCommon = () => {
  document.addEventListener('DOMContentLoaded', windowUpdate);
  // window update
  windowUpdate();
};

